import { apiClient } from './api';
import {
  MeResponse,
  StoredPreferences,
  UserPreferencesPayload,
} from '../types/user';

const ME = '/api/v1/me';

/**
 * The signed-in user's own account and preferences (issue #378).
 *
 * Every route here is scoped to the caller's own Dex subject server-side — there
 * is no subject parameter to pass, so this service cannot read or write anyone
 * else's settings. Managing other people is adminUserService.
 */
export const userService = {
  /** Profile, roles and preferences in one call — used for the first paint. */
  async getMe(): Promise<MeResponse> {
    return apiClient.get<MeResponse>(ME);
  },

  /** The caller's stored preferences, or the server's defaults. */
  async getPreferences(): Promise<StoredPreferences> {
    return apiClient.get<StoredPreferences>(`${ME}/preferences`);
  },

  /**
   * Replaces the caller's preferences. A full replace, not a merge: the UI holds
   * the whole document, and sending part of it would let another open tab
   * resurrect values this one just changed.
   */
  async savePreferences(
    payload: UserPreferencesPayload
  ): Promise<StoredPreferences> {
    return apiClient.put<StoredPreferences>(`${ME}/preferences`, { payload });
  },
};
